<template lang="html">
  <div>
    <v-select v-model="id" @search="updateSearch" :required="required"
    :options="tutors"
    :filterable="false"
    placeholder="Seleziona tutor"
    :reduce="az => az.id">
      <template slot="no-options">
        Ricerca il tutor
      </template>
      <template #search="{attributes, events}">
        <input
          class="vs__search"
          :required="!id && required"
          v-bind="attributes"
          v-on="events"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: ['value', 'required'],
  data () {
    return {
      id: this.value || null,
      tutors: [],
      search: _.debounce((a, b, c) => this.doSearch(a, b, c), 350)
    }
  },

  created () {
    if (this.id) {
      let params = { id: this.id, max: 20 }
      this.doSearch(params)
    } else {
      this.doSearch()
    }
  },

  methods: {
    updateSearch (q, loading) {
      loading(true)
      let params = { q, id: this.id, max: 20 }
      this.search(params, loading)
    },

    doSearch(params, loading) {
      this.$http.get('tirocinio/tutor', { params }).then(res => {
        this.tutors = res.data.map(x => ({
          id: x.id,
          label: `${x.name} ${x.surname}`,
          // num_tirocini: x.tirocini.length
        }))
        // this.tutors = this.tutors.filter( tut => {
        //   if (tut.num_tirocini < 40) return tut
        // })
      }).finally(res => {
        loading && loading(false)
      })
    }
  },

  watch: {
    id (id) {
      this.$emit('input', id)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
